import React from "react";

export function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "blanchedalmond",
        borderRadius: "100%",
        paddingTop: "2px",
      }}
      onClick={onClick}
    />
  );
}

export function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "blanchedalmond",
        borderRadius: "100%",
        paddingTop: "2px",
      }}
      onClick={onClick}
    />
  );
}
